import Autocomplete from "./library/Autocomplete";
import COUNTRIES from "./countries";
import { isAllowedFilterField } from "../utils/UserHelper";

function CountriesAutocomplete(props: any) {
 
  // if( props.initialState.countries ){
  //   let array = props.initialState.countries.split(",");
  //   for (let index = 0; index < array.length; index++) {
  //     const urlCountry = array[index];
  //     for (let x = 0; x < COUNTRIES.length; x++) {
  //       const country = COUNTRIES[x];
  //       if (urlCountry == country.id){
  //         selected.push(country);
  //       }
  //     }
  //   }
  // }
  


  // let component = null;
  // if( selected.length > 0 ){
  //   component = <Autocomplete placeholder="Countries" id="cmbCountriesA" labelKey="name" onChange={props.onChange} options={COUNTRIES} defaultSelected={selected}/>;
  // }
  // else {
  //   component = <Autocomplete placeholder="Countries" id="cmbCountriesB" labelKey="name" onChange={props.onChange} options={COUNTRIES} />;
  //  }

  return <Autocomplete 
          id="countriesAutocomplete1"
          placeholder="Countries" 
          reactKey="countriesAutocomplete2"
          labelKey="name" 
          onChange={props.onChange} 
          onBlur={props.onBlur}
          style={props.style}
          options={props.options ? props.options : COUNTRIES} 
          selected={props.selected}
          paginate={false} 
          maxResults={COUNTRIES.length+1}
          reactRef={props.reactRef}
          onKeyDown={props.onKeyDown}
          useIncludeExclude={props.useIncludeExclude && isAllowedFilterField("countriesExclude")}
          defaultIncludeExclude={props.defaultIncludeExclude}
          includeExcludeOnChange={props.includeExcludeOnChange}
          multiple
          />;
}

export default CountriesAutocomplete;
